import React from "react";
import { Box, Wrap, WrapItem, Badge, Text, useColorModeValue } from "@chakra-ui/react";

/**
 * Renders a row of badge tags for subsection items.
 * @param {object} props
 * @param {Array<string>} props.items - List of item labels to display as badges
 * @returns {React.ReactElement}
 */
function SubsectionItems({ items }) {
    const itemColor = useColorModeValue("secondaryGray.700", "secondaryGray.300");
    return (
        <Wrap spacing="4px" ml="8px">
            {items.map((item, i) => (
                <WrapItem key={i}>
                    <Badge bg="whiteAlpha.200" color={itemColor} borderRadius="6px" px="6px"
                        fontSize="0.7rem" fontWeight="500" textTransform="none">{item}</Badge>
                </WrapItem>
            ))}
        </Wrap>
    );
}

/**
 * Renders a subsection content block within a legal document section.
 * Displays subtitle, content text, and optional item badges in read-only mode.
 * @param {object} props
 * @param {object} props.subsection - Subsection data with number, subtitle, content, items
 * @returns {React.ReactElement}
 */
function SubsectionView({ subsection }) {
    const subtitleColor = useColorModeValue("secondaryGray.900", "whiteAlpha.900");
    const contentColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
    return (
        <Box ml="16px" mb="12px">
            <Text fontSize="0.8rem" fontWeight="600" mb="2px" color={subtitleColor}>
                {subsection.number} {subsection.subtitle}
            </Text>
            {subsection.content && (
                <Text fontSize="0.78rem" mb="4px" whiteSpace="pre-line" color={contentColor}>
                    {subsection.content}
                </Text>
            )}
            {subsection.items?.length > 0 && <SubsectionItems items={subsection.items} />}
        </Box>
    );
}

export { SubsectionItems };
export default SubsectionView;
